export default __webpack_public_path__ + "static/media/ProfileWhite.60048d04.svg";